var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BadgeState',{attrs:{"label":_vm.message,"color":_vm.color,"icon":_vm.icon}})
}
var staticRenderFns = []

export { render, staticRenderFns }